<form class="ui static form" #form="ngForm">
    <app-segment-header title="performance.goal-summary.goalInformationTitle"></app-segment-header>
    <div class="four fields">
        <div class="field">
            <label class="font-medium">{{ 'performance.goal-summary.title' | translate }}</label>
            <div>{{ goal.title }}</div>
        </div>
        <div class="field">
            <label class="font-medium">{{ 'performance.goal-summary.metric' | translate }}</label>
            <div>{{ getGoalMetricTranslatable() | translate }}</div>
        </div>
    </div>
    <div class="four fields">
        <div class="twelve wide field">
            <label class="font-medium">{{ 'performance.goal-summary.description' | translate }}</label>
            <div>{{ goal.description }}</div>
        </div>
    </div>

    <mat-divider></mat-divider>

    <app-segment-header class="margin-top-3" title="performance.goal-summary.scheduleTitle"></app-segment-header>
    <div class="four fields">
        <div class="field">
            <label class="font-medium">{{ 'performance.goal-summary.startAt' | translate }}</label>
            <div>{{ goal.startAt | appDate: 'mediumDate' }}</div>
        </div>
        <div class="field">
            <label class="font-medium">{{ 'performance.goal-summary.dueAt' | translate }}</label>
            <div>{{ goal.dueAt | appDate: 'mediumDate' }}</div>
        </div>
    </div>

    <mat-divider></mat-divider>

    <app-segment-header class="margin-top-3" title="performance.goal-summary.participantsTitle"></app-segment-header>
    <div class="four fields">
        <div class="field">
            <label class="font-medium">{{ 'performance.goal-summary.employeesSelected' | translate }}</label>
            <div>{{ getParticipantCount() }}</div>
        </div>
    </div>
</form>
